module.exports = __webpack_public_path__ + "img/unsubscribe.0168c5b2.svg";